export const isPresentHelper = (page, product) =>
  !!page.find((item) => item._id === product._id);
